import React, { Fragment } from 'react';
import { StateProps } from '@/hooks/useWizard';

const getOrder = ({ index, pos, numItems }: Record<string, number>) => {
    return index - pos < 0 ? numItems - Math.abs(index - pos) : index - pos;
};

interface CarouselProps {
    numItems: number;
    children: React.ReactNode;
    state: StateProps;
}

const Carousel = ({ numItems, state, children }: CarouselProps) => {
    return (
        <div className="w-full overflow-hidden">
            <div key={state.pos} className="flex animate-fade-in">
                {React.Children.map(children, (child, index) => {
                    const order = getOrder({ index, pos: state.pos, numItems });

                    return order === 0 ? (
                        <div
                            key={index}
                            className="min-h-[250px] flex-[1_0_100%] basis-full"
                        >
                            {child}
                        </div>
                    ) : <Fragment key={index} />;
                })}
            </div>
        </div>
    );
};

export default Carousel;
